import * as React from 'react'

import { Input as OriginInput } from '../ui/input'

import { cn } from '../../lib/utils'

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, ...props }, ref) => {
    return (
      <OriginInput
        ref={ref}
        className={cn('bg-white text-[#515151]', className)}
        {...props}
      />
    )
  },
)

Input.displayName = 'Input'

export { Input }
